import {initWebComponent} from "@/helpers/web-component-helper";
import {addTemporaryLayer} from "@/helpers/layer/temporary/temporary-layer-helper";
import {
    getBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {startLadda} from "@/helpers/ladda-helper";

let layerCapabilities = []

export class BookmarkDataSetFileComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `

        <div class="card-body p-2">
            <div class="mt-1">
                <div class="btn-group btn-group-toggle bg-light p-1 d-flex" data-toggle="buttons">
                    <label data-type="SHP" class="btn btn-data-set-file btn-default btn-tools btn-sm md-btn-flat waves-effect active">
                        Shape
                    </label>
                    <label data-type="CSV" class="btn btn-data-set-file btn-default btn-tools btn-sm md-btn-flat waves-effect">
                        CSV
                    </label>
                    <label data-type="GeoJson" class="btn btn-data-set-file btn-default btn-tools btn-sm md-btn-flat waves-effect">
                        GeoJson
                    </label>
                </div>
            </div>
        </div>
     
         <div class="card-body p-2">
            <div class="form-group">
             <label class="form-label w-100">Kies bestand:</label>
              <input type="file" id="iptServiceFile" accept=".csv, .json, .geojson, .zip">
            </div> 
            <div class="form-group mt-2">
                <button id="btnLoadTemporaryLayerFile" class="btn btn-outline-secondary btn-block btn-sm">Laden</a>
            </div>
         </div>
         
         <div class="card-body p-2 d-none" id="divCsvFile">
            <p>
                Maak onder \`Type\` een keuze om te bepalen of de inhoud van de kolom kan dienen om de juiste locatie te vinden.
            </p>
            <p>
                Indien het een adres betreft, dat uit meerdere delen bestaat ( straatnaam, huisnummer, woonplaats) dan moeten de betreffende kolommen als Adres-deel-1, Adres-deel-2, Adres-deel-3 gekozen worden.
            </p>
            <div id="divCsvFileTable">
            <table class="table mt-2 table-bordered">
                <thead>
                    <th>Naam</th>
                    <th>Type</th>
                </thead>
                <tbody id="tblCsvFile">
                </tbody>
            </table>
            </div>
            
            <div class="form-group mt-2">
                <button id="btnAddTemporaryLayerFile" data-spinner-color="#858380" class="btn btn-outline-secondary btn-block btn-sm ladda-button">Toevoegen</a>
            </div>
          </div>
`
        initWebComponent(this, template)

        let activeFileType = 'CSV'
        getBySelector('#btnLoadTemporaryLayerFile').addEventListener('click', (evt) => {
            getBySelector('#tblCsvFile').innerHTML = ''
            hideElementsBySelector('#divCsvFile')
            switch (activeFileType) {
                case 'CSV':
                    addTemporaryLayer(activeFileType, layerCapabilities)
                    showElementsBySelector('#divCsvFile')
                    break;
                default:
                    addTemporaryLayer(activeFileType, layerCapabilities)
                    break;
            }
        })

        getBySelector('#btnAddTemporaryLayerFile').addEventListener('click', (evt) => {

            startLadda('#btnAddTemporaryLayerFile')
            switch (activeFileType) {
                case 'CSV':
                    addTemporaryLayer(activeFileType, layerCapabilities)
                    break;
            }
        })

        this.addEventListener('click', (evt) => {
            if (evt.target.dataset.type) {
                activeFileType = evt.target.dataset.type
                removeClassBySelector('.btn-data-set-file', 'active')
                evt.target.classList.add('active')
            }
        })
    }
}
